import React, { useState } from "react";
import { useGlobalStates } from "../../../context/GlobalStates";

const RightText = () => {
	const [isCopy, setIsCopy] = useState("copy");
	const { isTextArea, setIsTextArea } = useGlobalStates();

	const textAreaHandle = (event) => {
		setIsTextArea(event?.target?.value);

		if (isTextArea?.length > 0) {
			setIsCopy("copy");
		}
	};

	const copyHandleClick = () => {
		if (isTextArea?.length > 0) {
			setIsCopy("copied");

			setTimeout(() => {
				setIsCopy("copy");
			}, 2000);

			navigator.clipboard
				.writeText(isTextArea)
				.then(() => {
					console.log("Text is copied!");
				})
				.catch((error) => {
					console.log(
						"An error occurred while copying the text: ",
						error.message
					);
				});
		} else {
			setIsCopy("copy");
			console.log("Type or paste something to copy!");
		}
	};
	return (
		<div className="w-full sm:w-1/2">
			<div className="flex justify-between overflow-hidden">
				<p className="font-mono text-yellow-600 underline">converted:</p>
				<button
					title="copy text"
					onClick={copyHandleClick}
					className="hover:scale-105 transition-all duration-300 px-2 rounded-md bg-[#386641] text-white text-center"
				>
					{isCopy}
				</button>
			</div>
			<textarea
				autoFocus
				disabled
				className="border-l mt-1 p-1 outline-none shadow-md border-gray-200 w-full resize-none"
				rows={"20"}
				placeholder="you can not type but copy..."
				onChange={textAreaHandle}
				value={isTextArea}
			/>
		</div>
	);
};

export default RightText;
